import { getLeaderboardTimeframe } from "@/sales-tools/leaderboard/api/getLeaderboardTimeframe";

import { getGamificationApiClient } from "../../home-product/api/api";

interface TotalCallCountResponse {
    callCount: number;
}

export const getTotalCallCount = async (): Promise<TotalCallCountResponse> => {
    const { start, end } = getLeaderboardTimeframe();

    return await getGamificationApiClient()
        .get(`v1/metrics/calls?start=${start}&end=${end}`, { retry: 0 })
        .json<TotalCallCountResponse>();
};
